module.exports = __webpack_public_path__ + "static/media/fitness.ba0fafde.svg";